<mat-chip-set>
  @for (pl of workItem?.possibleProductionLines; track pl) {
    <mat-chip elderChipLabel [color]="getChipColor(pl.productionPath)">
      <div
        class="layout-col place-center-center narrow-chip"
        matBadgeOverlap="false"
        matBadgeColor="warn"
        matBadge="!"
        matBadgeHidden="{{ hasValidMakespan(pl) }}"
      >
        @for (wc of pl.workCenters; track wc) {
          <div>{{ wcMetas[wc.id].name }}</div>
        }
        <div style="font-size: x-small">{{ pl.makespan | isoDuration: 'hh:mm:ss' }}</div>
      </div>
    </mat-chip>
  }
</mat-chip-set>
